import React, { useState, useEffect } from "react";
import { Select, Button, Space } from "antd";
import CheckList from "container/CheckList/index";
import "./styles.css";
import ChecklistDocumentAccordion from "./ChecklistDocumentAccordion";
import { PlusOutlined } from "@ant-design/icons";
import AddChecklistTemplateModal from "./AddChecklistTemplateModal";
import NoTemplatesFound from "./NoTemplatesFound";
const ChecklistDocument = ({
  fetchChecklistMetadataResponse,
  fetchStatesMetadataResponse,
  fetchStatesMetadata,
  fetchChecklistMetadata,
  fetchTypeMetadata,
  fetchTypeMetadataResponse,
  fetchAllTemplates,
  addNewChecklistTemplateResponse,
  fetchAllChecklistDataResponse,
  fetchAllChecklistData,
  fetchBrbcDocuments,
  fetchAllTemplatesResponse,
  dropdownData,
}) => {
  const [localState, setLocalState] = useState("");
  const [localType, setLocalType] = useState("");
  const [localChecklist, setLocalChecklist] = useState("");
  const [newYorkSubType, setNewYorkSubType] = useState("one_key_mls");
    const [addNewChecklist, setAddNewChecklist] = useState(false);

  const [isAddChecklistModalOpen, setIsAddChecklistModalOpen] = useState(false);

  useEffect(() => {
    if (!localState && !localType) {
      fetchStatesMetadata();
      fetchTypeMetadata();
    }
  }, []);

  useEffect(() => {
    setLocalChecklist('');
  },[addNewChecklistTemplateResponse])

  // Get states options from API response
  const getStatesOptions = () => {
    if (!fetchStatesMetadataResponse?.data || !Array.isArray(fetchStatesMetadataResponse.data)) {
      return []
    }
    return fetchStatesMetadataResponse.data.map((stateItem) => ({
      label: stateItem.state,
      value: stateItem.state,
    }))
  }

  // Get subtypes for a selected state
  const getSubTypesForState = (stateName) => {
    if (!fetchStatesMetadataResponse?.data || !Array.isArray(fetchStatesMetadataResponse.data)) {
      return []
    }
    const stateData = fetchStatesMetadataResponse.data.find((s) => s.state === stateName)
    if (stateData && stateData.hasSubType && stateData.subtypes) {
      return stateData.subtypes.map((subtype) => ({
        label: subtype.key,
        value: subtype.value,
      }))
    }
    return []
  }

  // Check if state has subtypes
  const stateHasSubTypes = (stateName) => {
    if (!fetchStatesMetadataResponse?.data || !Array.isArray(fetchStatesMetadataResponse.data)) {
      return false
    }
    const stateData = fetchStatesMetadataResponse.data.find((s) => s.state === stateName)
    return stateData?.hasSubType || false
  }

  useEffect(() => {
    if (stateHasSubTypes(localState)) {
      const subtypes = getSubTypesForState(localState)
      if (subtypes.length > 0) {
        setNewYorkSubType(subtypes[0].value)
      }
    } else {
      setNewYorkSubType(undefined)
    }
  }, [localState, fetchStatesMetadataResponse])

  const fetchChecklistTemplates = (state, type, nySubType) => {
    setLocalType(type);
    const payload = {
      state: state,
      type: type,
      nySubType: nySubType,
    };
    dropdownData({
      state: state,
      type: type,
      checklistTemplate: null,
      nySubType: nySubType,
    });
    setLocalChecklist("");
    fetchChecklistMetadata(payload);
  };

  const fetchAllTemplatesData = (value) => {
    const checklist = fetchChecklistMetadataResponse?.data?.find(
      (e) => e.checklist_template_value === value
    );
    const payload = {
      state: localState,
      type: localType,
      checklistTemplate: checklist?.checklist_template_value,
      nySubType: newYorkSubType,
    };

    setLocalChecklist(checklist);
    dropdownData({
      state: localState,
      type: localType,
      checklistTemplate: checklist,
      nySubType: newYorkSubType,
    });
    fetchAllTemplates(payload);
    fetchAllChecklistData(payload);
    fetchBrbcDocuments({state: localState});
  };

  const openAddNewChecklistTemplate = () => {
    setIsAddChecklistModalOpen(true);
    setAddNewChecklist(true)
  };

  const closeModal = () => {
    setIsAddChecklistModalOpen(false);
  };
  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <>
      <div className="container">
        <div className="">
          <h1>Checklists</h1>
          <h5>
            A comprehensive guide to essential documents for seamless real
            estate transactions.
          </h5>
        </div>
        <div className="content-wrapper">
          <div className="dropdown-section">
            <div>
              <h4>State</h4>
              {!fetchStatesMetadataResponse?.isFetching ? (
                <Select
                  className="dropdown-state"
                  placeholder="Select State"
                  style={{ width: 300, marginTop: 0 }}
                  onChange={(value) => {
                    setLocalState(value);
                    // Get default subtype for the new state
                    const subtypes = getSubTypesForState(value);
                    const defaultSubType = subtypes.length > 0 ? subtypes[0].value : undefined;
                    setNewYorkSubType(defaultSubType);
                    if (localType) {
                      fetchChecklistTemplates(value, localType, defaultSubType);
                    }
                  }}
                  options={getStatesOptions()}
                />
              ) : (
                <div
                  className="loading-dropdown"
                  style={{ width: 300, marginTop: 0 }}
                >
                  Loading...
                </div>
              )}
            </div>

            {stateHasSubTypes(localState) && (
              <div>
                <h4 style={{ marginLeft: 20 }}>Sub Type</h4>
                <Select
                  value={newYorkSubType}
                  placeholder="Select Sub Type"
                  className="dropdown-state"
                  style={{ width: 300, marginLeft: 20, marginTop: 0 }}
                  onChange={(value) => {
                    setNewYorkSubType(value);
                    if (localType) {
                      fetchChecklistTemplates(localState, localType, value);
                    }
                  }}
                  options={getSubTypesForState(localState)}
                />
              </div>
            )}

            <div>
              <h4 style={{ marginLeft: 20 }}>Type</h4>
              {!fetchTypeMetadataResponse?.isFetching ? (
                <Select
                  placeholder="Select Type"
                  className="dropdown-state"
                  style={{ width: 300, marginLeft: 20, marginTop: 0 }}
                  onChange={(value) =>
                    fetchChecklistTemplates(localState, value, newYorkSubType)
                  }
                  options={
                    fetchTypeMetadataResponse?.data?.length > 0 &&
                    fetchTypeMetadataResponse?.data?.map((type) => ({
                      value: type,
                      label: capitalize(type),
                    }))
                  }
                />
              ) : (
                <div
                  className="loading-dropdown"
                  style={{ width: 300, marginLeft: 20, marginTop: 0 }}
                >
                  Loading...
                </div>
              )}
            </div>

            <div>
              <h4 style={{ marginLeft: 20 }}>Checklist Templates</h4>

              {!fetchChecklistMetadataResponse?.isFetching ? (
                <Select
                  placeholder="Select Checklist Template"
                  className="dropdown-state"
                  style={{ width: 300, marginLeft: 20, marginTop: 0 }}
                  disabled={!localState || !localType}
                  onChange={fetchAllTemplatesData}
                  dropdownRender={(menu) => (
                    <>
                      {menu}

                      <Space style={{ padding: "0 8px 4px" }}>
                        <button
                          style={{
                            color: "white",
                            width: "280px",
                          }}
                          className="add-due-btn add-due-btn-color"
                          type="text"
                          icon={<PlusOutlined />}
                          onClick={openAddNewChecklistTemplate}
                        >
                          Create New
                        </button>
                      </Space>
                    </>
                  )}
                  options={
                    fetchChecklistMetadataResponse?.data?.length > 0 &&
                    fetchChecklistMetadataResponse?.data
                      .filter((checklist) => {
                        // If New York is selected and subtype is selected, filter by subtype
                        if (localState === "New York" && newYorkSubType) {
                          return checklist.ny_sub_type === newYorkSubType
                        }
                        // If New York is selected but no subtype selected, show all NY templates (no filtering)
                        // For non-NY states, show all templates (API already filtered by state)
                        return true
                      })
                      .map((checklist) => ({
                        value: checklist.checklist_template_value,
                        label: checklist.checklist_template,
                      }))
                  }
                />
              ) : (
                <div
                  className="loading-dropdown"
                  style={{ width: 300, marginLeft: 20, marginTop: 0 }}
                >
                  Loading...
                </div>
              )}
            </div>
          </div>
        
          <>
            
            {localState && localType && localChecklist && (
              <>
                {fetchAllChecklistDataResponse?.isFetching ? (
                  <div className="loading">Loading...</div>
                ) : (
                    <>
                      {localState && localType && localChecklist && (Object.keys(fetchAllTemplatesResponse?.data || {}).length === 0 && !Array.isArray(fetchAllTemplatesResponse.data)) ?
                        <NoTemplatesFound setIsAddChecklistModalOpen={setIsAddChecklistModalOpen} setAddNewChecklist={ setAddNewChecklist} /> : null
                      }
                      <ChecklistDocumentAccordion />
                      </>
                )}
              </>
            )}
          </>
        </div>
   
        {isAddChecklistModalOpen && (
          <AddChecklistTemplateModal
            isAddChecklistModalOpen={isAddChecklistModalOpen}
            state={localState}
            type={localType}
            isAddingNew = {addNewChecklist}
            checklistTemplate={!addNewChecklist ? localChecklist : null}
            onCancel={closeModal}
          />
        )}
      </div>
    </>
  );
};

export default CheckList(ChecklistDocument);
